// import { MoreVert } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { NoDataContainer } from "../../Common/styles/table";
import {
  axisTickStyle,
  DashboardCardStyle,
  tooltipCardSx,
} from "../DashboardContent/style";
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  TooltipProps,
  XAxis,
  YAxis,
} from "recharts";

const CustomTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const datum: any = payload[0].payload;
  const value =
    typeof payload[0].value === "number"
      ? payload[0].value
      : datum?.value ?? datum?.duration ?? datum?.y ?? null;

  if (value === null) {
    return null;
  }
  const label = datum?.name ?? datum?.date ?? datum?.x ?? "-";

  return (
    <Box sx={tooltipCardSx}>
      <Typography variant="caption" color="text.secondary">
        Day : {label}
      </Typography>
      <Typography variant="subtitle1" color="text.primary" fontWeight={600}>
        Count : {value}
      </Typography>
    </Box>
  );
};

const ParticipantCreationOverTime = ({ data, handleOptionsClick }: any) => {
  const composedData = data?.data?.[0]?.data;
  const lineGradientId = "participant-over-time-line-gradient";
  const areaGradientId = "participant-over-time-area-gradient";
  return (
    <Box sx={DashboardCardStyle}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          color="text.primary"
        >
          {data?.title || "Participant Creation Over Time"}
        </Typography>
        {/* <Box>
          <IconButton onClick={(e) => handleOptionsClick(e, data)}>
            <MoreVert />
          </IconButton>
        </Box> */}
      </Box>
      <Box
        sx={{
          maxHeight: "460px",
        }}
      >
        {data?.data?.[0]?.data?.length === 0 ? (
          <NoDataContainer>
            <Typography variant="body1" color="gray">
              No data
            </Typography>
          </NoDataContainer>
        ) : (
          <Box sx={{ height: "370px" }}>
            <ResponsiveContainer width="100%" height={360}>
              <ComposedChart data={composedData}>
                <defs>
                  <linearGradient
                    id={lineGradientId}
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0%" stopColor="#7C3AED" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#7C3AED" stopOpacity={0.5} />
                  </linearGradient>
                  <linearGradient
                    id={areaGradientId}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#7C3AED" stopOpacity={0.3} />
                    <stop offset="50%" stopColor="#7C3AED" stopOpacity={0.15} />
                    <stop offset="100%" stopColor="#7C3AED" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#E5E7EB"
                  vertical={false}
                />
                <XAxis
                  dataKey="x"
                  interval="preserveStartEnd"
                  axisLine={false}
                  tick={axisTickStyle}
                  tickMargin={12}
                  angle={-45}
                  height={70}
                  textAnchor="end"
                />
                <YAxis
                  domain={[0, "auto"]}
                  allowDecimals={false}
                  axisLine={false}
                  tickLine={false}
                  tick={axisTickStyle}
                  tickMargin={8}
                  label={{
                    value: "Participants",
                    angle: -90,
                    position: "insideLeft",
                    style: { fill: "#6B7280", fontSize: 14 },
                  }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Area
                  type="monotone"
                  dataKey="y"
                  stroke="none"
                  fill={`url(#${areaGradientId})`}
                  fillOpacity={1}
                />
                <Line
                  type="monotone"
                  dataKey="y"
                  stroke={`url(#${lineGradientId})`}
                  strokeWidth={3}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  name="Participants creation over time"
                  dot={(props: any) => {
                    const { cx, cy, payload } = props;
                    // Don't render dot if value is 0 or null/undefined
                    if (!payload.y || payload.y === 0) {
                      return <></>;
                    }
                    return (
                      <circle
                        cx={cx}
                        cy={cy}
                        r={3}
                        fill="#7C3AED"
                        strokeWidth={2}
                        stroke="#7C3AED"
                      />
                    );
                  }}
                  activeDot={(props: any) => {
                    const { cx, cy, payload } = props;
                    // Don't render active dot if value is 0 or null/undefined
                    if (!payload.y || payload.y === 0) {
                      return <></>;
                    }
                    return (
                      <circle
                        cx={cx}
                        cy={cy}
                        r={6}
                        stroke="#7C3AED"
                        strokeWidth={2}
                        fill="#7C3AED"
                      />
                    );
                  }}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ParticipantCreationOverTime;
